import React from 'react';

// Ilustrações SVG originais, com as cores da marca (amarelo #FFD001 / preto).
// Nenhuma imagem de terceiros é usada — todas são vetoriais e escaláveis.

const P = '#FFD001';
const PD = '#E6BE2E';
const DARK = '#111111';
const DARK2 = '#1A1A1A';
const GRAY = '#2E2E2E';

// Moldura de celular reutilizável
const PhoneFrame = ({ children, className = '', style }) => (
  <div className={`driver-phone-svg ${className}`} style={style}>
    <svg viewBox="0 0 260 540" width="100%" xmlns="http://www.w3.org/2000/svg" role="img">
      <rect x="6" y="6" width="248" height="528" rx="40" fill={DARK2} stroke={GRAY} strokeWidth="4" />
      <rect x="16" y="16" width="228" height="508" rx="32" fill="#0C0C0C" />
      <rect x="92" y="22" width="76" height="18" rx="9" fill={GRAY} />
      <foreignObject x="16" y="46" width="228" height="470">
        <div xmlns="http://www.w3.org/1999/xhtml" style={{ width: '228px', height: '470px' }}>
          {children}
        </div>
      </foreignObject>
    </svg>
  </div>
);

// Tela 1 — Novo pedido chegando
export const ScreenNewOrder = () => (
  <PhoneFrame>
    <div className="dphone-screen dphone-orders">
      <div className="dphone-status">
        <span className="dphone-online"><i /> Online</span>
        <strong>Leo Go</strong>
      </div>
      <div className="dphone-newcard">
        <span className="dphone-newtag">Novo pedido</span>
        <h5>Pizzaria Bella Massa</h5>
        <p>2,4 km • ~9 min até a coleta</p>
        <div className="dphone-earn">R$ 11,50</div>
        <div className="dphone-btn">Aceitar entrega</div>
      </div>
      <div className="dphone-mini">
        <span>Coleta</span>
        <b>Rua das Flores, 128</b>
      </div>
      <div className="dphone-mini">
        <span>Entrega</span>
        <b>Av. Brasil, 902 • Apto 51</b>
      </div>
    </div>
  </PhoneFrame>
);

// Tela 2 — Mapa / rota
export const ScreenRoute = () => (
  <PhoneFrame>
    <div className="dphone-screen dphone-map">
      <svg viewBox="0 0 228 300" width="100%" preserveAspectRatio="none" aria-hidden="true">
        <rect width="228" height="300" fill="#15181C" />
        <g stroke="#242A31" strokeWidth="10">
          <line x1="0" y1="70" x2="228" y2="70" />
          <line x1="0" y1="150" x2="228" y2="150" />
          <line x1="0" y1="230" x2="228" y2="230" />
          <line x1="60" y1="0" x2="60" y2="300" />
          <line x1="150" y1="0" x2="150" y2="300" />
        </g>
        <path d="M40 250 C 90 210, 70 150, 130 130 S 190 70, 190 40" fill="none" stroke={P} strokeWidth="6" strokeLinecap="round" strokeDasharray="2 12" />
        <circle cx="40" cy="250" r="9" fill={P} />
        <circle cx="190" cy="40" r="9" fill="#fff" stroke={P} strokeWidth="4" />
      </svg>
      <div className="dphone-nav">
        <div className="dphone-nav-ico">↑</div>
        <div>
          <b>Siga em frente</b>
          <span>450 m • Av. Brasil</span>
        </div>
        <div className="dphone-nav-eta">7 min</div>
      </div>
    </div>
  </PhoneFrame>
);

// Tela 3 — Ganhos
export const ScreenEarnings = () => {
  const bars = [40, 62, 48, 80, 95, 70, 88];
  const days = ['S', 'T', 'Q', 'Q', 'S', 'S', 'D'];
  return (
    <PhoneFrame>
      <div className="dphone-screen dphone-earnings">
        <span className="dphone-label">Ganhos da semana</span>
        <h4>R$ 842,90</h4>
        <p className="dphone-up">▲ 18% vs. semana anterior</p>
        <div className="dphone-chart">
          {bars.map((h, i) => (
            <div key={i} className="dphone-bar-wrap">
              <div className="dphone-bar" style={{ height: `${h}%` }} />
              <small>{days[i]}</small>
            </div>
          ))}
        </div>
        <div className="dphone-payout">
          <span>Disponível para saque</span>
          <b>R$ 842,90</b>
        </div>
      </div>
    </PhoneFrame>
  );
};

// Hero — entregador com scooter (ilustração de linha)
export const HeroScooter = () => (
  <svg viewBox="0 0 420 360" width="100%" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Entregador em uma scooter">
    <defs>
      <radialGradient id="glow" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor={P} stopOpacity="0.28" />
        <stop offset="100%" stopColor={P} stopOpacity="0" />
      </radialGradient>
    </defs>
    <circle cx="210" cy="150" r="180" fill="url(#glow)" />
    {/* chão */}
    <line x1="40" y1="300" x2="380" y2="300" stroke={GRAY} strokeWidth="4" strokeLinecap="round" />
    {/* rodas */}
    <circle cx="130" cy="290" r="34" fill="none" stroke="#fff" strokeWidth="6" />
    <circle cx="130" cy="290" r="10" fill={P} />
    <circle cx="300" cy="290" r="34" fill="none" stroke="#fff" strokeWidth="6" />
    <circle cx="300" cy="290" r="10" fill={P} />
    {/* corpo da scooter */}
    <path d="M130 290 L200 250 L300 250" fill="none" stroke={P} strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M300 250 L320 190 L338 190" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M200 250 L182 205 L150 205" fill="none" stroke="#fff" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    {/* baú de entrega */}
    <rect x="96" y="150" width="70" height="62" rx="10" fill={P} stroke={DARK} strokeWidth="3" />
    <path d="M110 181 h42 M131 166 v30" stroke={DARK} strokeWidth="4" strokeLinecap="round" />
    {/* entregador */}
    <circle cx="238" cy="150" r="20" fill="#fff" />
    <path d="M238 128 a12 12 0 0 1 12 12 h-24 a12 12 0 0 1 12-12z" fill={P} />
    <path d="M238 170 L228 220 L300 250" fill="none" stroke="#fff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M238 185 L322 190" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
  </svg>
);

// Ícone de passo com número
export const StepBadge = ({ n }) => (
  <svg viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill={P} />
    <circle cx="32" cy="32" r="30" fill="none" stroke={PD} strokeWidth="3" />
    <text x="32" y="42" textAnchor="middle" fontSize="30" fontWeight="700" fontFamily="Poppins, sans-serif" fill={DARK}>{n}</text>
  </svg>
);

// Faixa decorativa de fundo (pontos)
export const DotPattern = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 200 200" width="200" height="200" aria-hidden="true">
    <defs>
      <pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse">
        <circle cx="2" cy="2" r="2" fill={P} fillOpacity="0.5" />
      </pattern>
    </defs>
    <rect width="200" height="200" fill="url(#dots)" />
  </svg>
);

const Illustrations = { ScreenNewOrder, ScreenRoute, ScreenEarnings, HeroScooter, StepBadge, DotPattern };
export default Illustrations;
